// MET value in kcal/h kg
export const hoover = 3.3;
export const jog = 7.0;
export const cycle = 7.5;
export const climb_stairs = 4.0;
export const walk = 2.8;
